// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration"; // Importing nothing to trigger the side effects, which in this case adds custom reducers.
import postStyleGuideTheme from "@stoneage/XDL/PostStyle";
import preStyleGuideTheme from "@stoneage/XDL/PreStyle";

setPreStyleGuideTheme(preStyleGuideTheme);
setPostStyleGuideTheme(postStyleGuideTheme);
